import { MetricBorders, RelativeMetricBorders } from "../model/metrics";

export const DEFAULT_BORDERS: {
  absolute: MetricBorders;
  difference: MetricBorders;
  relative: RelativeMetricBorders;
} = {
  absolute: {
    time_in_mins: [10, 20, 30, 40, 50, 60, Infinity],
    co2: [0, 2000, 4000, 6000, 8000, 10000, 12000, 14000, Infinity],
    cost: [0, 2, 4, 6, 8, 10, 12, 14, Infinity],
    sport: [0, 100, 250, 500, 750, 1000, 1250, 1500, Infinity],
    distance: [0, 10, 20, 30, 40, 50, 60, 70, Infinity],
  },
  difference: {
    time_in_mins: [
      -Infinity,
      -60,
      -45,
      -30,
      -15,
      -5,
      5,
      15,
      30,
      45,
      60,
      Infinity,
    ],
    co2: [
      -Infinity,
      -1000,
      -750,
      -500,
      -250,
      -50,
      50,
      250,
      500,
      750,
      1000,
      Infinity,
    ],
    cost: [
      -Infinity,
      -10,
      -7.5,
      -5,
      -2.5,
      -0.5,
      0.5,
      2.5,
      5,
      7.5,
      10,
      Infinity,
    ],
    sport: [
      -Infinity,
      -1000,
      -750,
      -500,
      -250,
      -50,
      50,
      250,
      500,
      750,
      1000,
      Infinity,
    ],
    distance: [
      -Infinity,
      -50,
      -37.5,
      -25,
      -12.5,
      -2.5,
      2.5,
      12.5,
      25,
      37.5,
      50,
      Infinity,
    ],
  },
  relative: [
    -Infinity, // >100% better
    -100, // bis 100%
    -75, // bis 75%
    -50, // bis 50%
    -25, // bis 25%
    -5, // +/- 5%
    5, // bis 25%
    25, // bis 50%
    50, // bis 75%
    75, // bis 100%
    100, // >100% worse
    Infinity, // >100% worse
  ],
};

export const WORKER_MARKER_OPTIONS = {
  opacity: 0.8,
};
